/**
 * Turn double-newlines into paragraphs.
 * @param {String} text - Text
 * @param {String} [pre='<p>'] - The opening tag
 * @param {String} [post='</p>'] - The closing tag
 * @returns {String} - HTML string
 */
export default (text, pre = '<p>', post = '</p>') => `${pre}${text.trim().replace(/\r?\n\r?\n/g, `${post}${pre}`)}${post}`
